import React from 'react';
import { motion, useMotionValue, animate } from 'framer-motion';

export default function SwipeMessage({ msg, onReply, handlePointerDown, handlePointerUp, elevated = false, children, ...props }) {
  const x = useMotionValue(0);

  const handleDragEnd = (event, info) => {
    if (info.offset.x > 50 && typeof onReply === 'function') {
      onReply(msg);
    }
    animate(x, 0, { type: 'spring', stiffness: 150 });
  };

  return (
    <motion.div
      drag={elevated ? false : 'x'}
      dragConstraints={{ left: 0, right: 100 }}
      style={{
        x,
        zIndex: elevated ? 100 : 'auto',
        position: elevated ? 'fixed' : 'relative',
        top: elevated ? 136 : 'auto',
        left: elevated ? (msg?.is_sent_by_you ? 'auto' : 16) : 'auto',
        right: elevated ? (msg?.is_sent_by_you ? 16 : 'auto') : 'auto',
        margin: 0,
        width: elevated ? 'max-content' : 'auto',
        maxWidth: elevated ? '16rem' : 'inherit',
      }}
      animate={
        elevated
          ? { scale: 1.04, y: -8, boxShadow: 'none' }
          : { scale: 1, y: 0, boxShadow: 'none' }
      }
      transition={{ type: 'spring', stiffness: 500, damping: 30 }}
      onDragEnd={handleDragEnd}
      onPointerDown={handlePointerDown}
      onPointerUp={handlePointerUp}
      {...props}
    >
      {children}
    </motion.div>
  );
}
